const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPorcentagemTratativas(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "master-artboard",
    viewBox: "0 0 503.5628967285156 446.98333740234375",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    style: {
      enableBackground: "new 0 0 1400 980"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.450656771659851, 0, 0, 0.450656771659851, 6.28594971711459, -3.634204098537481)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(5.343433380126952, 0, 0, 5.343433380126952, 1155.7828696449956, 22.866363769801524)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "ee-background",
    x: 0,
    y: 0,
    width: 503.5628967285156,
    height: 446.98333740234375,
    style: {
      fill: "white",
      fillOpacity: 0,
      pointerEvents: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.03664058446884155, 0, 0, 0.03664058446884155, -625.5484771728516, -369.62646484375)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camada_x0020_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil3 area_cor_padrao_grafico_direita",
    name: "tratativa-1",
    d: "M13955.98 10344.76c0,98.12 -79.55,177.7 -177.68,177.7 -98.23,0 -177.81,-79.58 -177.81,-177.7 0,-98.13 79.58,-177.71 177.81,-177.71 98.13,0 177.68,79.58 177.68,177.71z",
    style: {
      fill: "rgb(187, 194, 199)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil3 area_cor_padrao_grafico_direita",
    name: "tratativa-2",
    d: "M14178.18 10374.02c25.45,-94.78 122.88,-150.97 217.69,-125.63 94.78,25.45 150.97,122.88 125.64,217.69 -25.34,94.78 -122.88,150.97 -217.58,125.63 -94.81,-25.45 -151.09,-122.79 -125.75,-217.69z",
    style: {
      fill: "rgb(187, 194, 199)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil3 area_cor_padrao_grafico_direita",
    name: "tratativa-3",
    d: "M14728.67 10551.81c49.01,-84.95 157.66,-114.02 242.72,-65.02 84.98,49.12 114.14,157.77 65.02,242.73 -49.01,85.06 -157.74,114.13 -242.72,65.12 -84.96,-49.11 -114.14,-157.76 -65.02,-242.83z",
    style: {
      fill: "rgb(187, 194, 199)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil3 area_cor_padrao_grafico_direita",
    name: "tratativa-4",
    d: "M15214.22 10866.07c69.45,-69.45 182.03,-69.45 251.36,0 69.44,69.33 69.44,181.9 0,251.27 -69.33,69.33 -181.91,69.33 -251.36,0 -69.36,-69.37 -69.36,-181.94 0,-251.27z",
    style: {
      fill: "rgb(187, 194, 199)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil3 area_cor_padrao_grafico_direita",
    name: "tratativa-5",
    d: "M15602.02 11295.24c85.06,-49.12 193.71,-19.97 242.75,65.01 49.09,84.96 19.93,193.61 -65.05,242.72 -84.95,49.12 -193.71,19.94 -242.72,-65.01 -49.12,-84.98 -19.94,-193.72 65.02,-242.72z",
    style: {
      fill: "rgb(187, 194, 199)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil3 area_cor_padrao_grafico_direita",
    name: "tratativa-6",
    d: "M15960.48 11810.05c94.81,-25.36 192.24,30.94 217.69,125.72 25.34,94.81 -30.94,192.24 -125.64,217.69 -94.89,25.34 -192.24,-30.93 -217.69,-125.74 -25.42,-94.79 30.86,-192.24 125.64,-217.67z",
    style: {
      fill: "rgb(187, 194, 199)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil3 area_cor_padrao_grafico_direita",
    name: "tratativa-7",
    d: "M16081.71 12375.66c98.13,0 177.68,79.55 177.68,177.68 0,98.15 -79.55,177.7 -177.68,177.7 -98.15,0 -177.7,-79.55 -177.7,-177.7 0,-98.13 79.55,-177.68 177.7,-177.68z",
    style: {
      fill: "rgb(187, 194, 199)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil3 area_cor_padrao_grafico_direita",
    name: "tratativa-8",
    d: "M16052.53 12953.33c94.7,25.36 150.98,122.9 125.64,217.58 -25.45,94.89 -122.88,151.08 -217.69,125.74 -94.78,-25.45 -151.06,-122.88 -125.64,-217.69 25.45,-94.78 122.8,-151.05 217.69,-125.63z",
    style: {
      fill: "rgb(187, 194, 199)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil3 area_cor_padrao_grafico_direita",
    name: "tratativa-9",
    d: "M15779.72 13503.82c84.98,49 114.14,157.65 65.05,242.63 -49.04,85.07 -157.69,114.14 -242.75,65.02 -84.96,-49.01 -114.14,-157.65 -65.02,-242.61 49.01,-85.09 157.77,-114.16 242.72,-65.04z",
    style: {
      fill: "rgb(187, 194, 199)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil3 area_cor_padrao_grafico_direita",
    name: "tratativa-10",
    d: "M15465.58 13989.37c69.44,69.45 69.44,181.91 0,251.38 -69.33,69.34 -181.91,69.34 -251.36,0 -69.36,-69.47 -69.36,-181.93 0,-251.38 69.45,-69.36 182.03,-69.36 251.36,0z",
    style: {
      fill: "rgb(187, 194, 199)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil3 area_cor_padrao_grafico_direita",
    name: "tratativa-11",
    d: "M15036.41 14377.19c49.12,84.95 19.96,193.69 -65.02,242.72 -85.06,49.12 -193.71,19.94 -242.72,-65.04 -49.12,-84.96 -19.94,-193.69 65.02,-242.72 84.98,-49.12 193.71,-19.94 242.72,65.04z",
    style: {
      fill: "rgb(187, 194, 199)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil3 area_cor_padrao_grafico_direita",
    name: "tratativa-12",
    d: "M14521.51 14640.74c25.33,94.78 -30.86,192.13 -125.64,217.58 -94.81,25.34 -192.24,-30.85 -217.69,-125.75 -25.34,-94.7 30.94,-192.24 125.75,-217.46 94.7,-25.45 192.24,30.74 217.58,125.63z",
    style: {
      fill: "rgb(187, 194, 199)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil3 area_cor_padrao_grafico_direita",
    name: "tratativa-13",
    d: "M13955.98 14761.84c0,98.23 -79.55,177.81 -177.68,177.81 -98.23,0 -177.81,-79.58 -177.81,-177.81 0,-98.13 79.58,-177.6 177.81,-177.6 98.13,0 177.68,79.47 177.68,177.6z",
    style: {
      fill: "rgb(187, 194, 199)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil4 area_cor_padrao_grafico_direita",
    name: "tratativa-14",
    d: "M13034.99 14640.74c25.34,-94.89 122.88,-151.08 217.69,-125.63 94.67,25.22 151.06,122.76 125.64,217.46 -25.45,94.9 -122.91,151.09 -217.69,125.75 -94.79,-25.45 -150.98,-122.8 -125.64,-217.58z",
    style: {
      fill: "rgb(187, 194, 199)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil4 area_cor_padrao_grafico_direita",
    name: "tratativa-15",
    d: "M12520.06 14377.19c49.04,-84.98 157.77,-114.16 242.72,-65.04 84.98,49.03 114.17,157.76 65.05,242.72 -49.01,84.98 -157.66,114.16 -242.64,65.04 -85.07,-49.03 -114.25,-157.77 -65.13,-242.72z",
    style: {
      fill: "rgb(187, 194, 199)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil4 area_cor_padrao_grafico_direita",
    name: "tratativa-16",
    d: "M12090.89 13989.37c69.36,-69.36 181.94,-69.36 251.38,0 69.36,69.45 69.36,181.91 0,251.38 -69.44,69.34 -182.02,69.34 -251.38,0 -69.44,-69.47 -69.44,-181.93 0,-251.38z",
    style: {
      fill: "rgb(187, 194, 199)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil4 area_cor_padrao_grafico_direita",
    name: "tratativa-17",
    d: "M11776.78 13503.82c84.95,-49.12 193.68,-20.05 242.72,65.04 49.12,84.96 19.94,193.6 -65.05,242.61 -85.06,49.12 -193.68,20.05 -242.72,-65.02 -49.12,-84.98 -19.94,-193.63 65.05,-242.63z",
    style: {
      fill: "rgb(187, 194, 199)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil4 area_cor_padrao_grafico_direita",
    name: "tratativa-18",
    d: "M11598.96 12953.33c94.81,-25.42 192.24,30.85 217.58,125.63 25.45,94.81 -30.83,192.24 -125.64,217.69 -94.78,25.34 -192.21,-30.85 -217.66,-125.74 -25.34,-94.68 30.94,-192.22 125.72,-217.58z",
    style: {
      fill: "rgb(187, 194, 199)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil4 area_cor_padrao_grafico_direita",
    name: "tratativa-19",
    d: "M11569.7 12375.66c98.12,0 177.7,79.55 177.7,177.68 0,98.15 -79.58,177.7 -177.7,177.7 -98.13,0 -177.71,-79.55 -177.71,-177.7 0,-98.13 79.58,-177.68 177.71,-177.68z",
    style: {
      fill: "rgb(187, 194, 199)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil4 area_cor_padrao_grafico_direita",
    name: "tratativa-20",
    d: "M11690.9 11810.05c94.81,25.43 151.09,122.88 125.64,217.67 -25.34,94.81 -122.77,151.08 -217.58,125.74 -94.78,-25.45 -151.06,-122.88 -125.72,-217.69 25.45,-94.78 122.88,-151.08 217.66,-125.72z",
    style: {
      fill: "rgb(187, 194, 199)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil4 area_cor_padrao_grafico_direita",
    name: "tratativa-21",
    d: "M11954.45 11295.24c84.99,49 114.17,157.74 65.05,242.72 -49.04,84.95 -157.77,114.13 -242.72,65.01 -84.99,-49.11 -114.17,-157.76 -65.05,-242.72 49.04,-84.98 157.66,-114.13 242.72,-65.01z",
    style: {
      fill: "rgb(187, 194, 199)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil4 area_cor_padrao_grafico_direita",
    name: "tratativa-22",
    d: "M12342.27 10866.07c69.36,69.33 69.36,181.9 0,251.27 -69.44,69.33 -182.02,69.33 -251.38,0 -69.44,-69.37 -69.44,-181.94 0,-251.27 69.36,-69.45 181.94,-69.45 251.38,0z",
    style: {
      fill: "rgb(187, 194, 199)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil4 area_cor_padrao_grafico_direita",
    name: "tratativa-23",
    d: "M12827.83 10551.81c49.12,85.07 19.93,193.72 -65.05,242.83 -84.95,49.01 -193.68,19.94 -242.72,-65.12 -49.12,-84.96 -19.94,-193.61 65.13,-242.73 84.98,-49 193.63,-19.93 242.64,65.02z",
    style: {
      fill: "rgb(187, 194, 199)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil4 area_cor_padrao_grafico_direita",
    name: "tratativa-24",
    d: "M13378.32 10374.02c25.42,94.9 -30.97,192.24 -125.64,217.69 -94.81,25.34 -192.35,-30.85 -217.69,-125.63 -25.34,-94.81 30.85,-192.24 125.64,-217.69 94.78,-25.34 192.24,30.85 217.69,125.63z",
    style: {
      fill: "rgb(187, 194, 199)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 12063.17,
    y: 12151.02,
    className: "fil1 fnt1 area_cor_fonte_grafico_direita",
    style: {
      whiteSpace: "pre",
      fill: "rgb(138, 141, 144)",
      fontWeight: "bold",
      fontSize: "570.9px",
      fontFamily: "'Arial'",
      fontWeight: "Arial"
    }
  }, "TRATATIVAS")))), /*#__PURE__*/React.createElement("text", {
    className: "single-line-text percentuais tratamento_formatted area_cor_tratativa_grafico_direita",
    dominantBaseline: "middle",
    style: {
      whiteSpace: "pre",
      textAnchor: "middle",
      fill: "rgb(238, 67, 127)",
      fontWeight: "bold",
      fontSize: "203.57px",
      textAlign: "center",
      fontFamily: "Arial",
      color: "rgb(238, 67, 127)"
    },
    x: 710,
    y: 630,
    transform: "matrix(1, 0, 0, 1, -180.04503439523023, 16.36773061418853)",
    name: "tratamento_formatted"
  }, "0%")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPorcentagemTratativas);
export default __webpack_public_path__ + "static/media/porcentagem_tratativas.35587f9481d81ba506d2fe49dbce6943.svg";
export { ForwardRef as ReactComponent };